import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router";

import { Button, Divider } from "../Controls";

import { fetchResponse } from "../../actions/actions.js";

import texts from "../../assets/strings/response.js";

import "./styles.less";

class Response extends Component {
  componentWillMount() {
    const {
      fetchResponse,
      params: { id }
    } = this.props;
    if (id) {
      fetchResponse(id);
    }
  }

  render() {
    return (
      <div className="response mobile">
        <section className="intro">
          <h2>{texts.h1}</h2>
          <p>{texts.h3}</p>
        </section>
        <section className="how-it-works">
          <p>{texts.step1}</p>
          <p>{texts.step2}</p>
          <p>{texts.step3}</p>
        </section>
        <section className="actions">
          <Link to="/proceed">
            <Button label={texts.action} primary={true} large={true} />
          </Link>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    reducer: state.detailsReducer
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchResponse
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Response);



// WEBPACK FOOTER //
// ./components/Response/Response.js